import React from 'react';
import ErrorNotFound from '../Components/Common/Error/ErrorNotFound';

function Error404 (props) {
 return(
      <>
        <ErrorNotFound buttonText={props.buttonText} handleClickButton={props.handleClickButton}/>
      </>
 );
}

  
export default Error404;